import { useEffect } from 'react';

export function useAos(delay = 0) {
  useEffect(() => {
    let cancelled = false;
    let observer;
    let frameId = 0;
    let startId = 0;
    const pending = new Map();

    const flush = () => {
      frameId = 0;
      pending.forEach((visible, el) => {
        el.classList.toggle('aos-visible', visible);
      });
      pending.clear();
    };

    const setup = () => {
      if (cancelled) return;

      const elements = document.querySelectorAll('[data-aos]');
      if (!elements.length) return;

      observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            pending.set(entry.target, entry.isIntersecting);
          }
          if (!frameId) {
            frameId = requestAnimationFrame(flush);
          }
        },
        { rootMargin: '-120px 0px', threshold: 0 },
      );

      elements.forEach((el) => observer.observe(el));
    };

    const timer = window.setTimeout(() => {
      startId = requestAnimationFrame(() => {
        requestAnimationFrame(setup);
      });
    }, delay);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
      if (startId) cancelAnimationFrame(startId);
      observer?.disconnect();
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, [delay]);
}
